// @flow strict
import * as React from "react";
import type { RegisteredStore } from "~robin-hood/redux/store";
import { AGENT_NAME } from "~robin-hood/redux/store";
import classnames from "~common/classnames";
import styles from "./EquipoInfo.module.css";

type ExitProps = {
  exitEquipo: () => void,
};

function ExitButton(props: ExitProps): React$Node {
  return (
    <span className={styles.exit} onClick={() => void props.exitEquipo()}>
      Abandonar equipo
    </span>
  );
}

type EquipoInfoProps = { store: RegisteredStore, exitEquipo: () => void };
export function EquipoInfo(props: EquipoInfoProps): React$Node {
  const [open, setOpen] = React.useState(false);
  return (
    <div className={classnames(styles.equipoInfoFixed)}>
      <div className={styles.equipoOpen} onClick={() => setOpen(!open)}>
        <div className={styles.agentName}>
          Agente {AGENT_NAME.get(props.store.agent)}
        </div>
        <div
          className={classnames(
            styles.equipoOpenHandle,
            "fa fa-chevron-right",
            open && styles.open
          )}
        ></div>
      </div>
      <div
        className={classnames(styles.equipoInfoWrapper, open && styles.open)}
      >
        <div className={styles.equipoInfo}>
          <div className={styles.equipoLabels}>
            <span className={styles.label}>Equipo:</span>
            <span className={styles.label}>Jugadores:</span>
            <span className={styles.label}>Token:</span>
          </div>
          <div className={styles.equipoValues}>
            <span className={styles.value}> {props.store.equipo.name}</span>
            <span className={styles.value}> {props.store.equipo.players}</span>
            <span className={styles.value}>{props.store.equipo.id}</span>
          </div>
        </div>
        <ExitButton exitEquipo={props.exitEquipo} />
      </div>
    </div>
  );
}
